(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["timeline-split-block"] && !Shopify.designMode) return;
  try {
    (() => {
  const blocks = Array.from(document.querySelectorAll('.timeline-split-block'));
  if (!blocks.length) return;

  const ratios = new Map();

  const setActive = (el) => {
    blocks.forEach(b => {
      const dot = b.querySelector('.timeline-dot');
      if (!dot) return;
      dot.classList.toggle('active', b === el);
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
    });

    let best = null, bestRatio = 0;
    ratios.forEach((ratio, el) => {
      if (ratio > bestRatio) { bestRatio = ratio; best = el; }
    });

    if (best) setActive(best);
  }, {
    root: null,
    rootMargin: '-20% 0px -20% 0px',
    threshold: Array.from({ length: 21 }, (_, i) => i / 20)
  });

  blocks.forEach(el => {
    ratios.set(el, 0);
    observer.observe(el);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
